<template>
  <div>
    <DialogFull
      :data="dialogSettings"
      @close="close"
      noOverflow
      v-if="dialogSettings.dialog"
    >
      <template v-slot:dialog.body>
        <v-form class="my-10 container" ref="form" lazy-validation>
          <TextField
            :disabled="isLoading"
            label="Name"
            class="mb-4 mt-2"
            @change="organisationData.name = $event"
            outlined
            dense
            :rules="isRequired('Name', shouldValidate)"
            with-errors
          />
          <TextField
            :disabled="isLoading"
            label="Cost Code (optional)"
            :value="organisationData.costCode"
            class="mb-4 mt-2"
            @change="organisationData.costCode = $event"
            outlined
            dense
          />
          <Select
            autocomplete
            :disabled="isLoading"
            @change="organisationData.parent.id = $event"
            :value="organisationData.parent.id"
            label="Parent Organisation Unit"
            placeholder="Select Organisation Unit"
            :items="units"
            item-text="name"
            item-value="id"
            :rules="isRequired('Parent Organisation Unit', shouldValidate)"
          >
            <template v-slot:selection="{ data }">
              <div class="py-2">
                <div class="d-flex">
                  <strong v-text="data.item.name" />
                  <strong class="ml-1">
                    {{ data.item.costCode && `(${data.item.costCode})` }}
                  </strong>
                </div>
                <p class="secondary-text">{{ data.item.subText }}</p>
              </div>
            </template>
            <template v-slot:item="{ item }">
              <div class="py-2">
                <div class="d-flex">
                  <strong v-text="item.name" />
                  <strong class="ml-1">
                    {{ item.costCode && `(${item.costCode})` }}
                  </strong>
                </div>
                <p class="secondary-text">{{ item.subText }}</p>
              </div>
            </template>
          </Select>
        </v-form>
      </template>
      <template v-slot:dialog.action>
        <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
          Create Organisation Unit
        </PrimaryButton>
      </template>
    </DialogFull>
  </div>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { ORGANISATION_UNITS_NAMESPACE } from "@/store/modules/organisations/organisation-units";
import { createNamespacedHelpers } from "vuex";
import { isRequired } from "@/utils/validation/rules";
import Select from "@/components/common/Select";
import TextField from "@/components/common/TextField";
import { CREATE_ORGANISATION_UNIT } from "@/store/modules/organisations/organisation-units/actions";
import { copyState } from "@/utils/helpers";
import { getUnitsWithParents } from "@/utils/organisation-units";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_UNITS_NAMESPACE
);

export default {
  name: "CreateUnitDialog",
  components: { TextField, Select, PrimaryButton, DialogFull },
  props: {
    initialParent: Object,
    open: Boolean
  },
  data() {
    return {
      isDialogOpen: false,
      isLoading: false,
      shouldValidate: false,
      organisationData: {
        name: "",
        costCode: "",
        organisationType: this.initialParent
          ? this.initialParent.organisationType
          : "client",
        parent: {
          id: this.initialParent ? this.initialParent.id : ""
        }
      },
      dialogSettings: {
        dialog: this.open,
        title: "New Organisation Unit"
      }
    };
  },
  computed: {
    ...mapState(copyState(["organisationUnits"])),
    isValid() {
      return this.organisationData.name && this.organisationData.parent.id;
    },
    units() {
      return getUnitsWithParents(this.organisationUnits);
    }
  },
  methods: {
    ...mapActions({
      createOrganisationUnit: CREATE_ORGANISATION_UNIT
    }),
    isRequired,
    close() {
      this.$emit("close");
    },
    async handleSubmit() {
      this.shouldValidate = true;
      this.$refs.form.validate();
      if (this.isValid) {
        this.isLoading = true;
        await this.createOrganisationUnit(this.organisationData);
        this.close();
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
p {
  margin-bottom: 0 !important;
}
</style>
